import { articlesAll, PARAS, PULL_QUOTE_TEMPLATES } from "./db";

// Simulate a network delay
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const getSeedFromSlug = (slug) => {
  if (!slug) return 0;
  let hash = 0;
  for (let i = 0; i < slug.length; i++) {
    hash = slug.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash);
};

const pickN = (arr, n, seed) => {
  // Deterministic rotation based on seed so each story is consistent.
  const out = [];
  for (let i = 0; i < n; i++) out.push(arr[(seed + i) % arr.length]);
  return out;
};

const buildArticleBody = (item) => {
  const seed = getSeedFromSlug(item.slug);
  return {
    body: pickN(PARAS, 7, seed),
    pullQuote: PULL_QUOTE_TEMPLATES[seed % PULL_QUOTE_TEMPLATES.length],
    // Fallback if the article does not specify its own published date
    published: item.published || "December 2025",
  };
};

export const getAllArticles = async () => {
  await delay(500);
  return [...articlesAll].sort((a, b) => {
    const dateA = a.publishedAt ? new Date(a.publishedAt).getTime() : 0;
    const dateB = b.publishedAt ? new Date(b.publishedAt).getTime() : 0;
    return dateB - dateA;
  });
};

export const getArticleBySlug = async (slug) => {
  await delay(500);
  const item = articlesAll.find((a) => a.slug === slug);
  if (!item) return null;
  return { ...item, ...buildArticleBody(item) };
};

export const getRelatedArticles = (currentSlug, limit = 3) => {
  const related = articlesAll.filter((a) => a.slug !== currentSlug);
  return related
    .sort((a, b) => {
      const dateA = a.publishedAt ? new Date(a.publishedAt).getTime() : 0;
      const dateB = b.publishedAt ? new Date(b.publishedAt).getTime() : 0;
      return dateB - dateA;
    })
    .slice(0, limit);
};
